import {makeStyles} from '@logistics-frontend/blocks'
import {theme} from '@logistics-frontend/blocks/lpc/theme'

export const useClasses = makeStyles(
  {
    root: {
      '& .amber-button__text': {
        margin: 0,
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      '& .amber-button': {
        borderRadius: 16,
        padding: theme.spacing(1, 2, 1, 1.3),
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(1, 0),
        },
      },
    },
  },
  {name: 'PassportUser'},
)
